import { Redirect, Route } from 'react-router-dom';
import {
  AUTH_STATE,
  AUTH_STATE_KEY,
  SUPPORT_ROUTINGS
} from '../../define/global';
import ErrorPage from './ErrorPage';
import StartModeRouter from './StartModeRouter';

const FormatRouter = ({ match, location }) => {
  const format = match.params.format;
  const url = `${match.path}/:startMode`;

  // if (format === 'authOK') {
  //   localStorage.setItem(AUTH_STATE_KEY, AUTH_STATE.AUTH_SUCCESS);
  //   window.close();
  //   //return <>authOK</>;
  // }

  const productFormatInfo = SUPPORT_ROUTINGS.find(
    (ele) => ele.producType === match.params.productType
  );

  if (productFormatInfo !== undefined) {
    if (productFormatInfo.formatUnderDev.includes(format)) {
      return (
        <ErrorPage
          emoji={'🚧'}
          title="COMMING SOON"
          msg={` 해당 페이지는 개발중입니다. 조금만 기다려주세요.`}
        />
      );
    } else if (productFormatInfo.supportFormats.includes(format) === false) {
      return (
        <>
          <ErrorPage msg={`${match.params.productType} 에서는  ${format}을 지원하지 않습니다. `} />
        </>
      );
    }
  } else {
    return (
      <>
        <ErrorPage msg={`${match.params.productType} 에서는  ${format}을 지원하지 않습니다. `} />
      </>
    );
  }

  return (
    <>
      <Route exact path={`${match.path}`}>
        <Redirect to={`${match.url}${match.url.endsWith('/') ? '' : '/'}openDialog`} />
      </Route>
      <Route path={url} component={StartModeRouter}></Route>
    </>
  );
};

export default FormatRouter;
